import { defineComponent as _defineComponent } from 'vue'
import { useContext, nextTick } from '@nuxtjs/composition-api';
import { computed, ref } from 'vue';
import StatsCard from '~/components/Collections/StatsCard.vue';
import { TStatsCard, EStatsCardType } from '~/types/collections';
import FilmCollectionRewardCard from '~/components/FilmCollection/Overview/FilmCollectionRewardCard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RewardsStats',
  props: {
    items: { default: () => [] },
    containerClass: { default: '' },
    innerContainerClass: { default: 'd-flex flex-column flex-sm-row justify-space-between full-width' },
    itemContainerClass: { default: '' },
    includeMobileExpander: { type: Boolean, default: false },
    on: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as { items: TStatsCard[], containerClass: string, innerContainerClass: string, itemContainerClass: string, includeMobileExpander: boolean, on?: Record<string, any> };



const { $vuetify } = useContext();
const isExpanded = ref<boolean>(false);
const includeMobileExpander = computed(
  () => $vuetify.breakpoint.xs && props.includeMobileExpander,
);

const handleExpansionToggle = () => {
  nextTick(() => {
    isExpanded.value = !isExpanded.value;
  });
};

return { __sfc: true,emit, props, $vuetify, isExpanded, includeMobileExpander, handleExpansionToggle, StatsCard, EStatsCardType, FilmCollectionRewardCard }
}

})